import { render, staticRenderFns } from "./JdsTableCell.vue?vue&type=template&id=6f5242d5&scoped=true&"
import script from "./JdsTableCell.vue?vue&type=script&lang=ts&"
export * from "./JdsTableCell.vue?vue&type=script&lang=ts&"
import style0 from "./JdsTableCell.vue?vue&type=style&index=0&id=6f5242d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5242d5",
  null
  
)

export default component.exports